Namespace 'Common'

class Common.SvgIconView extends Backbone.View
  template: JST['backbone/templates/common/svg_icon']
  className: 'svg-icon-container'

  initialize: ({svgPath, svgId, iconClass}) ->
    @svgPath = svgPath
    @svgId = svgId
    @iconClass = iconClass

  render: ->
    @$el.html @template
      svgPath: window.image_path(@svgPath)
      svgId: @svgId
      iconClass: @iconClass
    @
